import { Fragment, useContext } from 'react';
import { TicketDetailContext } from 'src/contexts/ticketDetail.context';
import { UseFormIdEn } from 'src/types/helpdesk/ticketCategory.type';
import { AccessForm, EmailForm, ManpowerSupplyForm, TicketForm } from './TicketDetailForm';

// import ManpowerSupplyForm from './TicketDetailForm/manpowerSupplyForm';

const TicketDetailInformationCollection = () => {
  const { ticket } = useContext(TicketDetailContext);
  return (
    <Fragment>
      {ticket?.data?.ticketCategory?.useForm === UseFormIdEn.emailForm ? (
        <EmailForm />
      ) : ticket?.data.ticketCategory?.useForm === UseFormIdEn.accessForm ? (
        <AccessForm />
      ) : ticket?.data.ticketCategory?.useForm === UseFormIdEn.manpowerSupplyForm ? (
        <ManpowerSupplyForm />
      ) : (
        (ticket?.data?.ticketForms.length || 0) > 0 && <TicketForm />
      )}
    </Fragment>
  );
};
export default TicketDetailInformationCollection;
